import { API_endpoints } from "../config";

export const getParentBookingCounter = async (kidIds = []): Promise<any> => {
    try {
        const body = { kidIds } ;

        const response = await fetch(API_endpoints.getParentBookingCounter, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(body),
        });
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Fehler beim Laden von Buchungszähler Daten.");
        }
        const data = await response.json();
        return data;

    } catch (error) {
        console.error("Fehler beim Laden von Buchungszähler Daten:", error);
    }
};
